import { FileExtension } from '@/modules/shared/schemas/FileExtension'

import { axios, Response } from '../index'
import { Post } from './get-post-by-id'

export type Mention = {
  id: string
  type: 'GROUP' | 'PERSON' | 'ACCESS_PROFILE'
}

export type MentionCreatePost = {
  mentionedId: string
  mentionedType: 'GROUP' | 'PERSON' | 'ACCESS_PROFILE'
}

export type PostFileRequest = {
  fileName: string
  originalFileName: string | null
  size: number
  uploadedBy: string
  folderId: string
  fileContentType: FileExtension
}

export type UserGroupRequest = {
  personaGroupId: number
}

export type CreatePublishPostDTO = {
  content: string
  mentions: MentionCreatePost[]
  important: boolean
  postFilesRequest: PostFileRequest[]
  postTasksIds: string[]
  poll?: {
    multipleAnswers: boolean
    options: {
      name: string
    }[]
  }
  publisherModules: 'FEED'
  userGroupIds: UserGroupRequest[]
  commentBlocked: boolean
  postDeletedTheDateAndTime: string | null
  timeOfPublication?: string
}

export default function publishPost(
  ownerId: string,
  body: CreatePublishPostDTO
): Response<Post> {
  return axios.post(`/v6/posts/${ownerId}`, body)
}

export const publishPostFromDrive = (
  ownerId: string,
  body: CreatePublishPostDTO
): Response<Post> => {
  return axios.post(`/v6/drive/posts/${ownerId}`, body)
}
